import React from 'react';


export class SvgIco extends React.PureComponent {

  static defaultProps = {
    size: 18,
  };

  render() {
    const { size, height, width, name, onClick, className } = this.props;

    // Use id's from assets/images/common-icons.svg
    return (
      <svg
        className={className || ''}
        onClick={onClick || null}
        width={width ? width : size}
        height={height ? height : size}
        id={`svg-${name}`}
      >
        <use href={`#common-icons-${name}`} />
      </svg>
    );
  }
}

export const KeyboardArrowRightRounded = ({ size }) =>
  <SvgIco name="keyboard-arrow-right-rounded" size={size} />;

export const KeyboardArrowLeftRounded = ({ size }) =>
  <SvgIco name="keyboard-arrow-left-rounded" size={size} />;

export const KeyboardArrowRightRoundedIos = ({ size }) =>
  <SvgIco name="keyboard-arrow-right-rounded-ios" size={size} />;

export const KeyboardArrowLeftRoundedIos = ({ size }) =>
  <SvgIco name="keyboard-arrow-left-rounded-ios" size={size} />;


export const DetailedViewSet = {
  videos: <SvgIco name="video" size={20} />,
  photos: <SvgIco name="photos" size={20} />,
  'floor-plans': <SvgIco name="floor-plan" size={20} />,
  virtual_tour: <SvgIco name="virtual-tour" size={20} />,
  map: <SvgIco name="map_detail" size={20} />,
};

export const SocialIcons = {
  facebook: <SvgIco name="facebook-sign" />,
  twitter: <SvgIco name="twitter-sign" />,
  linkedin: <SvgIco name="linkedin-sign" />,
  google: <SvgIco name="google-sign" />,
};
